import React from 'react';

import {
	Icon,
	styled
} from 'ps-gui';

import { ReactComponent as AlertIcon } from '../svg/alert.svg';

const Wrapper = styled.div`
	display: table;
	background: #FFDA55;
	border-radius: 15px;
	box-shadow: -4px 2px 33px rgba(0, 0, 0, 0.1);
	padding: ${props => props.padding || '8px'};
	margin: ${props => props.margin || '8px auto'};
	max-width: ${props => props.maxWidth};
	color: ${props => props.theme.disabledTextColor};
	text-align: justify;

	&.freeFlow {
		padding: ${props => props.padding || '16px'};
		.alertIcon {
			float: left;
			margin-right: 8px;
		}
	}

	.closeMessage {
		float: right;
		margin-left: 16px;
		margin-bottom:16px;
	}

	b {
		font-weight: 700;
	}

	a {
		color: #297FCA;
		text-decoration: none;
		&:hover {
			text-decoration: underline;
		}
	}
`;

const Cell = styled.div`
	padding: 8px;
	display: table-cell;
	vertical-align: ${props => props.valign || 'middle'};
	white-space: pre-wrap;
`;

export default class Message extends React.Component {
	render() {
		return (
			<Wrapper className={'message ' + (this.props.freeFlow ? 'freeFlow' : '')} padding={this.props.padding} margin={this.props.margin} maxWidth={this.props.maxWidth}>
				{
					this.props.freeFlow ?
						<>
							<AlertIcon className="alertIcon" />
							{this.props.children}
						</>
						:
						<>
							<Cell valign={this.props.valign}>
								<AlertIcon />
							</Cell>
							<Cell valign={this.props.valign}>
								{
									this.props.onClose &&
									<Icon
										className="closeMessage"
										name="close"
										active
										onMouseDown={this.props.onClose}
									/>

								}
								{this.props.children}
							</Cell>
						</>

				}
			</Wrapper>
		);
	}
}

